import {
  Button,
  Card,
  Col,
  Row,
  Typography,
  Form,
  Tabs,
  Space,
  Modal,
} from "antd";
import { LeftOutlined, RightOutlined, BookOutlined, InboxOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProduct } from "../../redux/actions/product/addProductAction";
import { updateProduct } from "../../redux/actions/product/updateProductAction";
import { loadSingleProduct } from "../../redux/actions/product/detailProductAction";
import { globalProductSearch } from "../../redux/actions/product/globalSearchAction";
import { loadAllProductCategory } from "../../redux/actions/productCategory/getProductCategoryAction";
import { loadAllBookPublisher } from "../../redux/actions/bookPublisher/getBookPublisherAction";
import { loadAllProductCurrency } from "../../redux/actions/productCurrency/getProductCurrencyAction";
import { loadAllLocations } from "../../redux/actions/location/getLocationAction";
import { debounce } from "../../utils/debounce";
import StockEntriesTab from "./components/StockEntriesTab";
import AddLocation from "../location/addLocation";
import styles from "./AddProd.module.css";
import book from './../../assets/images/book.jpg'

import ISBNScanner from "../../utils/ISBNScanner";
import { BasicInfoFields } from "./components/ProductForm";
import ProductImageUpload from "./components/ProductImageUpload";
import ProductModals from "./components/ProductModals";

const TAB_KEYS = { BASIC: "basic", STOCK: "stock" };
const TAB_ORDER = [TAB_KEYS.BASIC, TAB_KEYS.STOCK];


const AddProd = ({ editMode = false, editData = null, onClose = null }) => {
  const unitType = ["copy", "set"];
  const category = useSelector((state) => state.productCategories?.list);
  const publisher = useSelector((state) => state.bookPublishers?.list);
  const currency = useSelector((state) => state.productCurrencies?.list);
  const locations = useSelector((state) => state.locations?.list) || [];
  const productList = useSelector((state) => state.products.list);
  // console.log("productList", productList);
  // console.log("pub id", publisher)


  const dispatch = useDispatch();
  //useEffect for loading category list from redux
  useEffect(() => {
    dispatch(loadAllProductCategory({ page: 1, limit: 100 }));
  }, [dispatch]);

  const dispatchPub = useDispatch();
  //useEffect for loading publisher list from redux
  useEffect(() => {
    dispatchPub(loadAllBookPublisher({ page: 1, limit: 1000 }));
  }, [dispatchPub]);

  const dispatchCurr = useDispatch();
  //useEffect for loading currency list from redux
  useEffect(() => {
    dispatchCurr(loadAllProductCurrency({ page: 1, limit: 100 }));
  }, [dispatchCurr]);

  const dispatchLoc = useDispatch();
  useEffect(() => {
    dispatchLoc(loadAllLocations());
  }, [dispatchLoc]);

  const { Title } = Typography;
//   var r = new FileReader();
// r.onload = function(){ alert(r.result); };

  // Book image: add = placeholder (not sent); edit = set from editData.imageUrl in useEffect
  const [fileList, setFileList] = useState([{ uid: '-2', name: 'default', status: 'done', url: book }]);
  const [loader, setLoader] = useState(false);
  const [isAdd,setIsAdd]=useState(false);
  const [type,setType]=useState(false);
  const [form] = Form.useForm();
  
  // State for dynamic + icon behavior
  const [publisherSearchValue, setPublisherSearchValue] = useState('');
  const [categorySearchValue, setCategorySearchValue] = useState('');
  const [showPublisherAdd, setShowPublisherAdd] = useState(false);
  const [showCategoryAdd, setShowCategoryAdd] = useState(false);
  const [prefillPublisherText, setPrefillPublisherText] = useState('');
  const [prefillCategoryText, setPrefillCategoryText] = useState('');
  
  // Camera scanning states
  const [isCameraModalVisible, setIsCameraModalVisible] = useState(false);
  // Stock entries (multiple per product)
  const [stockEntries, setStockEntries] = useState([]);
  // Add location modal (from Stock tab: prefill name and callback to set new location in form)
  const [addLocationModalVisible, setAddLocationModalVisible] = useState(false);
  const [addLocationPrefillName, setAddLocationPrefillName] = useState("");
  const [addLocationOnAdded, setAddLocationOnAdded] = useState(null);
  // Tab navigation (Basic → Pricing → Stock)
  const [activeTabKey, setActiveTabKey] = useState(TAB_KEYS.BASIC);
  // ISBN autocomplete (add mode): match existing books or allow new ISBN
  const [isbnMatches, setIsbnMatches] = useState([]);
  const [isbnSearching, setIsbnSearching] = useState(false);
  const [selectedExistingProduct, setSelectedExistingProduct] = useState(null);
  const selectingIsbnRef = useRef(false);

  const isUpdating = Boolean(editMode || selectedExistingProduct?.id);

  const applyProductToForm = useCallback(
    (product) => {
      if (!product) return;

      let categoryIds = [];
      if (product.categories && Array.isArray(product.categories) && product.categories.length > 0) {
        categoryIds = product.categories.map((cat) => cat.id || cat);
      } else if (product.product_category_id) {
        categoryIds = [product.product_category_id];
      }

      form.setFieldsValue({
        isbn: product.isbn,
        name: product.name,
        author: product.author,
        book_publisher_id: product.book_publisher_id,
        product_category_ids: categoryIds,
        product_currency_id: product.product_currency_id,
        sale_price: product.sale_price,
        unit_measurement: product.unit_measurement,
        unit_type: product.unit_type || "copy",
      });
      form.setFields([{ name: "isbn", errors: [] }]);

      if (product.imageUrl) {
        setFileList([
          {
            uid: "-1",
            name: "existing-image",
            status: "done",
            url: product.imageUrl,
          },
        ]);
      } else {
        setFileList([{ uid: "-2", name: "default", status: "done", url: book }]);
      }

      if (product.product_stock && Array.isArray(product.product_stock) && product.product_stock.length > 0) {
        setStockEntries(
          product.product_stock.map((e) => ({
            locationId: e.location_id ?? e.location?.id ?? null,
            quantity: e.quantity,
            purchasePrice: 0,
            transactionDate: e.transactionDate
              ? typeof e.transactionDate === "string"
                ? e.transactionDate.slice(0, 10)
                : e.transactionDate
              : null,
          }))
        );
      } else {
        setStockEntries([]);
      }

      setSelectedExistingProduct(product);
    },
    [form]
  );

  const buildIsbnOptions = (products) =>
    (products || [])
      .filter((p) => p?.isbn)
      .slice(0, 20)
      .map((p) => {
        const price =
          p.sale_price != null && p.sale_price !== ""
            ? `₹${Number(p.sale_price).toLocaleString("en-IN", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}`
            : null;
        return {
          value: String(p.isbn),
          key: p.id,
          productId: p.id,
          label: (
            <div style={{ lineHeight: 1.25 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 8,
                  alignItems: "baseline",
                }}
              >
                <span style={{ fontWeight: 600, fontSize: 12 }}>{p.isbn}</span>
                {price ? (
                  <span style={{ fontWeight: 600, fontSize: 12, color: "#389e0d", whiteSpace: "nowrap" }}>
                    {price}
                  </span>
                ) : null}
              </div>
              <div style={{ fontSize: 12, color: "#666" }}>
                {p.name || "Untitled"}
                {p.author ? ` • ${p.author}` : ""}
              </div>
            </div>
          ),
        };
      });

  const debouncedIsbnSearch = useCallback(
    debounce(async (searchTerm) => {
      const term = String(searchTerm || "").trim();
      if (!term) {
        setIsbnMatches([]);
        setIsbnSearching(false);
        return;
      }

      setIsbnSearching(true);
      try {
        const localMatches = (Array.isArray(productList) ? productList : []).filter((p) =>
          String(p?.isbn || "")
            .toLowerCase()
            .includes(term.toLowerCase())
        );
        const result = await dispatch(globalProductSearch(term, 1, 30));
        const apiMatches =
          result?.status === "success" && Array.isArray(result.data) ? result.data : [];

        const byId = new Map();
        [...localMatches, ...apiMatches].forEach((p) => {
          if (p?.id != null) byId.set(p.id, p);
        });
        const merged = Array.from(byId.values()).filter((p) =>
          String(p?.isbn || "")
            .toLowerCase()
            .includes(term.toLowerCase())
        );
        setIsbnMatches(merged);
      } catch (error) {
        console.error("ISBN search error:", error);
        const localMatches = (Array.isArray(productList) ? productList : []).filter((p) =>
          String(p?.isbn || "")
            .toLowerCase()
            .includes(term.toLowerCase())
        );
        setIsbnMatches(localMatches);
      } finally {
        setIsbnSearching(false);
      }
    }, 300),
    [dispatch, productList]
  );

  const handleIsbnSearch = (value) => {
    if (editMode) return;
    debouncedIsbnSearch(value);
  };

  const handleIsbnSelect = async (value, option) => {
    if (editMode) return;
    selectingIsbnRef.current = true;
    const productId = option?.productId || option?.key;
    let product =
      isbnMatches.find((p) => p.id === productId) ||
      isbnMatches.find((p) => String(p.isbn) === String(value)) ||
      (Array.isArray(productList)
        ? productList.find((p) => String(p.isbn) === String(value))
        : null);

    try {
      if (product?.id) {
        const res = await dispatch(loadSingleProduct(product.id));
        const full = res?.data ?? res;
        if (full && full.id) product = full;
      }
      if (product) {
        applyProductToForm(product);
        toast.success("Existing book loaded — you can update details or stock");
      }
    } catch (error) {
      console.error("Failed to load product by ISBN:", error);
      if (product) applyProductToForm(product);
    } finally {
      setTimeout(() => {
        selectingIsbnRef.current = false;
      }, 0);
    }
  };

  const handleIsbnInputChange = (value) => {
    if (editMode || selectingIsbnRef.current) return;
    const typed = String(value || "").trim();
    if (
      selectedExistingProduct &&
      typed.toLowerCase() !== String(selectedExistingProduct.isbn || "").trim().toLowerCase()
    ) {
      setSelectedExistingProduct(null);
    }
    if (!typed) {
      setIsbnMatches([]);
      setSelectedExistingProduct(null);
    }
  };

  // Initialize form with edit data if in edit mode
  useEffect(() => {
    if (editMode && editData && publisher && category && currency) {
      console.log("Setting form values for edit mode:", {
        editData,
        publisher: publisher.length,
        category: category.length,
        currency: currency.length
      });
      
      // Handle categories - support both old single category and new multiple categories
      let categoryIds = [];
      if (editData.categories && Array.isArray(editData.categories) && editData.categories.length > 0) {
        // New format: multiple categories
        categoryIds = editData.categories.map(cat => cat.id || cat);
      } else if (editData.product_category_id) {
        // Old format: single category (backward compatibility)
        categoryIds = [editData.product_category_id];
      }
      
      form.setFieldsValue({
        isbn: editData.isbn,
        name: editData.name,
        author: editData.author,
        book_publisher_id: editData.book_publisher_id,
        product_category_ids: categoryIds,
        product_currency_id: editData.product_currency_id,
        sale_price: editData.sale_price,
        unit_measurement: editData.unit_measurement,
        unit_type: editData.unit_type,
      });

      // Set existing image if available
      if (editData.imageUrl) {
        setFileList([{
          uid: '-1',
          name: 'existing-image',
          status: 'done',
          url: editData.imageUrl,
        }]);
      }

      // Prefill stock entries for edit mode (now derived from product_stock ledger)
      if (editData.product_stock && Array.isArray(editData.product_stock) && editData.product_stock.length > 0) {
        const mapped = editData.product_stock.map((e) => ({
          locationId: e.location_id ?? e.location?.id ?? null,
          quantity: e.quantity,
          purchasePrice: 0, // legacy UI field, no longer stored in DB
          transactionDate: e.transactionDate
            ? (typeof e.transactionDate === "string" ? e.transactionDate.slice(0, 10) : e.transactionDate)
            : null,
        }));
        setStockEntries(mapped);
      } else {
        setStockEntries([]);
      }
    }
  }, [editMode, editData, form, publisher, category, currency]);

  // Separate useEffect for resetting form when switching to add mode
  useEffect(() => {
    if (!editMode && editData === null) {
      form.resetFields();
      setFileList([{ uid: '-2', name: 'default', status: 'done', url: book }]);
      setStockEntries([]);
      setActiveTabKey(TAB_KEYS.BASIC);
    }
  }, [editMode, editData, form]);

  const isbnCheckTimerRef = useRef(null);

  const clearIsbnError = () => {
    form.setFields([{ name: "isbn", errors: [] }]);
  };

  // On blur: if exact ISBN match exists and nothing selected yet, autofill that product
  const checkForUniqueness = async (isbn) => {
    if (editMode || selectingIsbnRef.current) return;
    const v = String(isbn || "").trim();
    if (!v) {
      clearIsbnError();
      return;
    }
    if (
      selectedExistingProduct &&
      String(selectedExistingProduct.isbn || "").trim().toLowerCase() === v.toLowerCase()
    ) {
      clearIsbnError();
      return;
    }

    try {
      const result = await dispatch(globalProductSearch(v, 1, 10));
      const matches =
        result?.status === "success" && Array.isArray(result.data) ? result.data : [];
      const exact =
        matches.find((p) => String(p?.isbn || "").trim().toLowerCase() === v.toLowerCase()) ||
        (Array.isArray(productList)
          ? productList.find(
              (p) => String(p?.isbn || "").trim().toLowerCase() === v.toLowerCase()
            )
          : null);

      if (exact?.id) {
        const res = await dispatch(loadSingleProduct(exact.id));
        const full = res?.data ?? res;
        applyProductToForm(full?.id ? full : exact);
        clearIsbnError();
      } else {
        clearIsbnError();
      }
    } catch (error) {
      clearIsbnError();
    }
  };

  const handleIsbnChangeImmediate = (e) => {
    if (editMode) return;
    const v = e?.target?.value;
    handleIsbnInputChange(v);
    if (isbnCheckTimerRef.current) clearTimeout(isbnCheckTimerRef.current);
    // Keep dropdown results in sync while typing
    debouncedIsbnSearch(v);
  };

  // Clear ISBN selection state when switching to add mode
  useEffect(() => {
    if (!editMode && editData === null) {
      setSelectedExistingProduct(null);
      setIsbnMatches([]);
    }
  }, [editMode, editData]);

  const onFinish = async (values) => {
    console.log("=== FORM SUBMISSION START ===");
    console.log("Form submitted with values:", values);
    console.log("Publisher ID:", values.book_publisher_id);
    console.log("Category IDs:", values.product_category_ids);
    console.log("Currency ID:", values.product_currency_id);
    
    // Manual validation check
    if (!values.book_publisher_id) {
      console.log("❌ Publisher validation failed - no value");
      toast.error("Please select a publisher!");
      return;
    }
    if (!values.product_currency_id) {
      console.log("❌ Currency validation failed - no value");
      toast.error("Please select a currency!");
      return;
    }
    
    console.log("✅ All validations passed, proceeding with form submission");
    
    try {
      let formData = new FormData();
      const updateId = editMode && editData ? editData.id : selectedExistingProduct?.id || null;
      
      // Only append ISBN for new products, not for updates
      if (!updateId) {
      formData.append("isbn", values.isbn);
      }
      
      formData.append("name", values.name);
      formData.append("author", values.author);
      formData.append("book_publisher_id", values.book_publisher_id);
      
      // Handle multiple categories (optional field)
      if (values.product_category_ids && Array.isArray(values.product_category_ids) && values.product_category_ids.length > 0) {
        // Send as JSON string for easier parsing on backend
        formData.append("product_category_ids", JSON.stringify(values.product_category_ids));
      }
      
      formData.append("unit_type", values.unit_type);
      
      // Only append unit_measurement if it's provided (optional field)
      if (values.unit_measurement) {
      formData.append("unit_measurement", values.unit_measurement);
      }
      
      formData.append("product_currency_id", values.product_currency_id);
      formData.append("sale_price", values.sale_price);
      formData.append("quantity", "0");
      formData.append("purchase_price", "0");
      
      // Only append image if user selected a real file (not the placeholder)
      const imageFile = fileList[0]?.originFileObj;
      if (imageFile && imageFile instanceof File) {
        formData.append("image", imageFile);
      }

      // Append stock entries: create (with new productId) or update (replace for this product)
      // Always send so backend knows current state (including when user cleared all in edit mode)
      const stockPayload = stockEntries
        .filter((e) => e.locationId != null && e.quantity !== "" && e.quantity != null)
        .map((e) => ({
          locationId: e.locationId,
          quantity: Number(e.quantity),
          purchasePrice: Number(e.purchasePrice) || 0,
          transactionDate: e.transactionDate || new Date().toISOString().slice(0, 10),
        }));
      formData.append("stock_entries", JSON.stringify(stockPayload));

      let resp;
      if (updateId) {
        resp = await dispatch(updateProduct(updateId, formData));
      } else {
        resp = await dispatch(addProduct(formData));
      }

      if (resp.message === "success") {
        console.log("🎉 Product added/updated successfully!");
        form.resetFields();
        setFileList([{ uid: '-2', name: 'default', status: 'done', url: book }]);
        setStockEntries([]);
        setSelectedExistingProduct(null);
        setIsbnMatches([]);
        setLoader(false);

        // Close popup after successful update (edit list or ISBN-selected existing book)
        if (updateId && onClose) {
          onClose();
        }
      } else {
        console.log("❌ Product add/update failed:", resp);
        setLoader(false);
      }
    } catch (error) {
      console.log(error.message);
      toast.error(isUpdating ? "error at updating" : "error at creating");
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Form validation failed:", errorInfo);
    console.log("Error fields:", errorInfo.errorFields);
    console.log("Form values:", errorInfo.values);
    setLoader(false);
    toast.error("Please fill all required fields!");
  };

  const handelChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const onClickLoading = () => {
    setLoader(true);
  };

  const openAddPopUp=(addType) =>{
    console.log(addType);
    setIsAdd(true);
    setType(addType);
  }

  // Handle publisher search and dynamic + icon
  const handlePublisherSearch = (value) => {
    setPublisherSearchValue(value);
    if (value && publisher) {
      const hasMatch = publisher.some(pub => 
        pub.name.toLowerCase().includes(value.toLowerCase())
      );
      setShowPublisherAdd(!hasMatch);
    } else {
      setShowPublisherAdd(false);
    }
  };

  // Handle category search and dynamic + icon
  const handleCategorySearch = (value) => {
    setCategorySearchValue(value);
    if (value && category) {
      const hasMatch = category.some(cat => 
        cat.name.toLowerCase().includes(value.toLowerCase())
      );
      setShowCategoryAdd(!hasMatch);
    } else {
      setShowCategoryAdd(false);
    }
  };

  // Add new publisher dynamically - open modal with pre-filled text
  const addNewPublisher = () => {
    if (!publisherSearchValue.trim()) return;
    
    console.log("Opening publisher modal with text:", publisherSearchValue);
    
    // Store the text to pre-fill the modal
    setPrefillPublisherText(publisherSearchValue);
    
    // Set the publisher name to be pre-filled in the modal
    setType('publisher');
    setIsAdd(true);
    
    // Clear the search state
    setPublisherSearchValue('');
    setShowPublisherAdd(false);
  };

  // Add new category dynamically - open modal with pre-filled text
  const addNewCategory = () => {
    if (!categorySearchValue.trim()) return;
    
    console.log("Opening category modal with text:", categorySearchValue);
    
    // Store the text to pre-fill the modal
    setPrefillCategoryText(categorySearchValue);
    
    // Set the category name to be pre-filled in the modal
    setType('category');
    setIsAdd(true);
    
    // Clear the search state
    setCategorySearchValue('');
    setShowCategoryAdd(false);
  };

  const closeAdd = (success = false) => {
    setIsAdd(false);
    
    // Store prefill text before clearing it
    const currentPublisherText = prefillPublisherText;
    const currentCategoryText = prefillCategoryText;
    
    // Clear prefill text when closing modal
    setPrefillPublisherText('');
    setPrefillCategoryText('');
    
    if (success) {
      if (type === 'publisher' && currentPublisherText) {
        // Refresh publisher data
        dispatchPub(loadAllBookPublisher({ page: 1, limit: 1000 }));
        
        // Wait for Redux state to update, then auto-select
        setTimeout(() => {
          if (publisher) {
            const newPublisher = publisher.find(pub => 
              pub.name.toLowerCase() === currentPublisherText.toLowerCase()
            );
            if (newPublisher) {
              form.setFieldsValue({
                book_publisher_id: newPublisher.id
              });
              console.log("Auto-selected publisher:", newPublisher.name);
              toast.success(`Publisher "${currentPublisherText}" added and selected!`);
            }
          }
        }, 1000);
      } else if (type === 'category' && currentCategoryText) {
        // Refresh category data
        dispatch(loadAllProductCategory({ page: 1, limit: 100 }));
        
        // Wait for Redux state to update, then auto-select
        setTimeout(() => {
          if (category) {
            const newCategory = category.find(cat => 
              cat.name.toLowerCase() === currentCategoryText.toLowerCase()
            );
            if (newCategory) {
              form.setFieldsValue({
                product_category_id: newCategory.id
              });
              console.log("Auto-selected category:", newCategory.name);
              toast.success(`Category "${currentCategoryText}" added and selected!`);
            }
          }
        }, 1000);
      }
    }
    // Note: We don't refresh data when user just closes modal without adding anything
    // This prevents unnecessary triggers of the useEffect that could reset the form
  }

  // Camera scanning functions
  const openCameraModal = () => {
    setIsCameraModalVisible(true);
  };

  const closeCameraModal = () => {
    setIsCameraModalVisible(false);
  };

  const handleISBNDetected = async (isbn) => {
    form.setFieldsValue({
      isbn: isbn
    });
    if (editMode || !isbn) return;

    closeCameraModal();
    debouncedIsbnSearch(isbn);

    try {
      const result = await dispatch(globalProductSearch(String(isbn).trim(), 1, 10));
      const matches =
        result?.status === "success" && Array.isArray(result.data) ? result.data : [];
      const exact = matches.find(
        (p) => String(p?.isbn || "").trim().toLowerCase() === String(isbn).trim().toLowerCase()
      );
      if (exact?.id) {
        const res = await dispatch(loadSingleProduct(exact.id));
        const full = res?.data ?? res;
        applyProductToForm(full?.id ? full : exact);
        toast.success("Existing book loaded from scanned ISBN");
      } else {
        setSelectedExistingProduct(null);
        clearIsbnError();
        toast.info("ISBN not found — enter details to add as new");
      }
    } catch (error) {
      console.error("ISBN scan lookup failed:", error);
    }
  };

  return (
    <Fragment>
      <Row gutter={[16, 16]} className={styles.formCardWrap}>
        {/* Main Form - Full width on mobile, 14 columns on desktop */}
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="rounded column-design">
          <Card bordered={false} className={styles.addBookCard}>
           
            <Form
              form={form}
              layout="vertical"
              initialValues={{
                book_publisher_id: undefined,
                product_category_ids: undefined,
                product_currency_id: undefined,
                unit_measurement: 1,
                unit_type: 'copy',
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Tabs
                activeKey={activeTabKey}
                onChange={setActiveTabKey}
                className={styles.bookTabs}
                items={[
                  {
                    key: TAB_KEYS.BASIC,
                    label: (
                      <span className={styles.tabLabel}>
                        <BookOutlined /> Basic Information
                      </span>
                    ),
                    children: (
                      <div className={styles.tabPane}>
                        <Row gutter={[24, 16]} wrap>
                          <Col xs={24} md={24} lg={16} xl={16}>
                            <BasicInfoFields
                              form={form}
                              editMode={editMode}
                              category={category}
                              publisher={publisher}
                              currency={currency}
                              unitType={unitType}
                              onCameraClick={openCameraModal}
                              checkForUniqueness={checkForUniqueness}
                              onIsbnChangeImmediate={handleIsbnChangeImmediate}
                              isbnOptions={buildIsbnOptions(isbnMatches)}
                              isbnSearching={isbnSearching}
                              onIsbnSearch={handleIsbnSearch}
                              onIsbnSelect={handleIsbnSelect}
                              onIsbnInputChange={handleIsbnInputChange}
                              selectedExistingProduct={selectedExistingProduct}
                              publisherSearchValue={publisherSearchValue}
                              setPublisherSearchValue={setPublisherSearchValue}
                              showPublisherAdd={showPublisherAdd}
                              setShowPublisherAdd={setShowPublisherAdd}
                              handlePublisherSearch={handlePublisherSearch}
                              addNewPublisher={addNewPublisher}
                              categorySearchValue={categorySearchValue}
                              setCategorySearchValue={setCategorySearchValue}
                              showCategoryAdd={showCategoryAdd}
                              setShowCategoryAdd={setShowCategoryAdd}
                              handleCategorySearch={handleCategorySearch}
                              addNewCategory={addNewCategory}
                            />
                          </Col>
                          <Col xs={24} md={24} lg={8} xl={8}>
                            <ProductImageUpload fileList={fileList} onFileChange={handelChange} />
                          </Col>
                        </Row>
                        <div className={styles.submitRow}>
                          <Button
                            type="primary"
                            size="large"
                            shape="round"
                            loading={loader}
                            className={styles.submitBtn}
                            onClick={() => form.submit()}
                          >
                            {isUpdating ? "Update " : "Save"}
                          </Button>
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: TAB_KEYS.STOCK,
                    label: (
                      <span className={styles.tabLabel}>
                        <InboxOutlined /> Inventory / Stock
                      </span>
                    ),
                    children: (
                      <div className={styles.tabPane}>
                        <StockEntriesTab
                          stockEntries={stockEntries}
                          onStockEntriesChange={setStockEntries}
                          locations={locations}
                          onOpenAddLocation={(prefillName, onAdded) => {
                            setAddLocationPrefillName(prefillName || "");
                            setAddLocationOnAdded(() => onAdded);
                            setAddLocationModalVisible(true);
                          }}
                        />
                        <div className={styles.submitRow}>
                          <Button
                            type="primary"
                            size="large"
                            shape="round"
                            loading={loader}
                            className={styles.submitBtn}
                            onClick={() => form.submit()}
                          >
                            {isUpdating ? "Update" : "Save"}
                          </Button>
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
              <div className={styles.tabActions}>
                <Space size="middle">
                  <Button
                    icon={<LeftOutlined />}
                    onClick={() => {
                      const idx = TAB_ORDER.indexOf(activeTabKey);
                      if (idx > 0) setActiveTabKey(TAB_ORDER[idx - 1]);
                    }}
                    disabled={activeTabKey === TAB_KEYS.BASIC}
                    className={styles.navBtn}
                  >
                    Previous
                  </Button>
                  {activeTabKey !== TAB_KEYS.STOCK ? (
                    <Button
                      type="primary"
                      onClick={() => {
                        form.validateFields(['isbn', 'name', 'book_publisher_id', 'product_currency_id', 'sale_price', 'unit_type']).then(() => {
                          const idx = TAB_ORDER.indexOf(activeTabKey);
                          if (idx < TAB_ORDER.length - 1) setActiveTabKey(TAB_ORDER[idx + 1]);
                        }).catch(() => {});
                      }}
                      icon={<RightOutlined />}
                      iconPosition="end"
                      className={styles.navBtn}
                    >
                      Next
                    </Button>
                  ) : null}
                </Space>
              </div>
            </Form>
          </Card>
        </Col>
      </Row>

       <ProductModals
         isAdd={isAdd}
         type={type}
         prefillPublisherText={prefillPublisherText}
         prefillCategoryText={prefillCategoryText}
         onCloseAdd={closeAdd}
       />

       <ISBNScanner
         isVisible={isCameraModalVisible}
         onClose={closeCameraModal}
         onISBNDetected={handleISBNDetected}
       />

       <Modal
         title="Add Location"
         open={addLocationModalVisible}
         onCancel={() => {
           setAddLocationModalVisible(false);
           setAddLocationPrefillName("");
           setAddLocationOnAdded(null);
         }}
         footer={null}
         destroyOnClose
       >
         <AddLocation
           inModal
           initialName={addLocationPrefillName}
           onSuccess={(newLocation) => {
             if (addLocationOnAdded && newLocation?.id) addLocationOnAdded(newLocation);
             setAddLocationModalVisible(false);
             setAddLocationPrefillName("");
             setAddLocationOnAdded(null);
             dispatchLoc(loadAllLocations());
           }}
           onCancel={() => {
             setAddLocationModalVisible(false);
             setAddLocationPrefillName("");
             setAddLocationOnAdded(null);
           }}
         />
       </Modal>
    </Fragment>
  );
};

export default AddProd;
